import { render } from "./TestControls.vue?vue&type=template&id=7a25a59e"
import script from "./TestControls.vue?vue&type=script&lang=js"
export * from "./TestControls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__